module.exports = __webpack_public_path__ + "img/mask02.fafd2b90.jpg";